
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface ComplianceScoreProps {
  name: string;
  progress: number;
  completed: number;
  pending: number;
}

const ComplianceScore: React.FC<ComplianceScoreProps> = ({ name, progress, completed, pending }) => {
  return (
    <Card className="relative overflow-hidden">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">{name}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Compliance Score</span>
          <span className="font-medium">{progress}%</span>
        </div>
        <Progress value={progress} className="h-2" />
        <div className="flex items-center justify-between mt-4 text-sm">
          <div>
            <span className="font-medium text-green-600">{completed}</span> Compliant
          </div>
          <div>
            <span className="font-medium text-red-600">{pending}</span> Pending
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComplianceScore;
